import { render, staticRenderFns } from "./FallbackSearch.vue?vue&type=template&id=609fb0f9&"
import script from "./FallbackSearch.vue?vue&type=script&lang=js&"
export * from "./FallbackSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports